import { projectStatusByCode, isInvoiceRepriceActive, isOwner } from 'entities';

import { WrenchIcon } from 'components/Icons';

import { registerProjectOption } from '../options';

import { AddServiceModal } from './AddServiceModal';

export default registerProjectOption({
  Icon: WrenchIcon,

  getLabel: (t) => t('add-new-service'),

  modal: 'ADD_SERVICE',
  overlay: AddServiceModal,

  shortcut: {
    key: 'E',
    triggerKey: ['ctrl'],
  },

  useOption: ({ loggedUser, project, openModal }) => {
    const { blocks } = projectStatusByCode[project.status];

    const canAddService = [
      !blocks.fullBlock,
      !blocks.newService,
      !!project.startedAt,
      isOwner(project, loggedUser),
      !isInvoiceRepriceActive(project),
    ].every(Boolean);

    return {
      isEnabled: canAddService,

      action: () => openModal('ADD_SERVICE'),
    };
  },
});
